import { selectAtom } from "jotai/utils";
import { shallowEqual } from "../../../utils/shallowEqual";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";

export const questionnaireCombinedErrorsAtom = selectAtom(
  questionnaireReducerAtom,
  state => ({
    ...state.errors,
    ...state.asyncErrors,
  }),
  shallowEqual,
);
